export interface Country {
  code: string;
  name: string;
  coordinates: [number, number];
}

// Countries we deliver to (ISO 3166-1 alpha-3 codes)
export const COUNTRIES: Country[] = [
  { code: 'TUR', name: 'Türkiye', coordinates: [35.0, 39.0] },
  { code: 'UZB', name: 'Özbekistan', coordinates: [64.0, 41.0] },
  { code: 'EGY', name: 'Mısır', coordinates: [30.0, 26.0] },
  { code: 'SAU', name: 'Suudi Arabistan', coordinates: [45.0, 25.0] },
  { code: 'ARE', name: 'Birleşik Arap Emirlikleri', coordinates: [54.0, 24.0] },
  { code: 'QAT', name: 'Katar', coordinates: [51.0, 25.5] },
  { code: 'KWT', name: 'Kuveyt', coordinates: [47.5, 29.5] },
  { code: 'OMN', name: 'Umman', coordinates: [57.0, 21.0] },
  { code: 'JOR', name: 'Ürdün', coordinates: [36.0, 31.0] },
  { code: 'LBN', name: 'Lübnan', coordinates: [35.5, 33.8] },
  { code: 'IRQ', name: 'Irak', coordinates: [44.0, 33.0] },
  { code: 'IRN', name: 'İran', coordinates: [53.0, 32.0] },
  { code: 'AZE', name: 'Azerbaycan', coordinates: [47.5, 40.5] },
  { code: 'KAZ', name: 'Kazakistan', coordinates: [66.0, 48.0] },
  { code: 'KGZ', name: 'Kırgızistan', coordinates: [74.0, 41.0] },
  { code: 'TKM', name: 'Türkmenistan', coordinates: [59.0, 39.0] },
  { code: 'TJK', name: 'Tacikistan', coordinates: [71.0, 39.0] },
  { code: 'AFG', name: 'Afganistan', coordinates: [66.0, 33.0] },
  { code: 'PAK', name: 'Pakistan', coordinates: [69.0, 30.0] },
  { code: 'DEU', name: 'Almanya', coordinates: [10.5, 51.0] },
  { code: 'FRA', name: 'Fransa', coordinates: [2.0, 46.0] },
  { code: 'GBR', name: 'Birleşik Krallık', coordinates: [-2.0, 54.0] },
  { code: 'ITA', name: 'İtalya', coordinates: [12.5, 41.5] },
  { code: 'ESP', name: 'İspanya', coordinates: [-3.0, 40.0] },
  { code: 'NLD', name: 'Hollanda', coordinates: [5.0, 52.0] },
  { code: 'BEL', name: 'Belçika', coordinates: [4.5, 50.5] },
  { code: 'CHE', name: 'İsviçre', coordinates: [8.0, 47.0] },
  { code: 'AUT', name: 'Avusturya', coordinates: [13.5, 47.5] },
  { code: 'RUS', name: 'Rusya', coordinates: [100.0, 60.0] },
  { code: 'IND', name: 'Hindistan', coordinates: [77.0, 20.0] }
];
